import { CommonModule } from "@angular/common";
import {
  Component,
  DOCUMENT,
  EventEmitter,
  inject,
  Input,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { SnackBarService } from "@services/snack-bar.service";
import { QrCodeModule } from "ng-qrcode";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";
import { PixUiState } from "../pipes/map-pix-response.pipe";

@Component({
  selector: "app-pix-section",
  imports: [CommonModule, ButtonComponent, QrCodeModule],
  templateUrl: "./pix-section.component.html",
  styleUrl: "./pix-section.component.scss",
})
export class PixSectionComponent {
  private readonly router = inject(Router);
  private readonly snackbarService = inject(SnackBarService);
  private readonly document = inject(DOCUMENT);

  @Input() pixData: PixUiState | null = null;
  @Input() loading = false;
  @Input() statusPaymentPix: string = "";
  @Input() isWebSocketConnected = false;
  @Input() showInternationalHint = false;
  @Input() canGenerateQr = true;

  @Output() generateQrCodeClick = new EventEmitter();

  getPixExpirationTime(): string {
    if (!this.pixData || !this.pixData.expiresAt) {
      return "";
    }

    try {
      const expiresDate = new Date(this.pixData.expiresAt);
      const now = new Date();
      const diffMs = expiresDate.getTime() - now.getTime();
      const diffMinutes = Math.floor(diffMs / 60000);

      if (diffMinutes <= 0) {
        return "Expirado";
      }

      const hours = Math.floor(diffMinutes / 60);
      const minutes = diffMinutes % 60;

      if (hours > 0) {
        return `Expira em ${hours}h ${minutes}min`;
      } else {
        return `Expira em ${minutes} minutos`;
      }
    } catch (error) {
      return "";
    }
  }

  // TODO: atualizar pra usar navigator.clipboard
  copyPixKey(): void {
    if (this.pixData?.copyPasteCode) {
      // Cria um input invisível
      const input = this.document.createElement("input");
      input.style.position = "fixed";
      input.style.opacity = "0";
      input.value = this.pixData?.copyPasteCode;
      this.document.body.appendChild(input);

      // Seleciona o texto do input
      input.select();
      input.setSelectionRange(0, 99999); // Para dispositivos móveis

      // Executa o comando 'copy'
      this.document.execCommand("copy");

      // Remove o input
      this.document.body.removeChild(input);

      this.snackbarService.openSnackBar(
        "Pix copia e cola copiado com sucesso!",
        "Fechar",
        "success",
      );
    } else {
      // Lidar com o caso em que this.pixData?.copyPasteCode é undefined/null
      this.snackbarService.openSnackBar(
        "Erro ao copiar pix!",
        "Fechar",
        "erro",
      );
    }
  }

  goToMyOrders(): void {
    this.router.navigate(["/my-orders"]);
  }

  handleGenerateQrCodeClick() {
    if (!this.canGenerateQr) return;
    this.generateQrCodeClick.emit();
  }
}
